import "./LeetCode.scss";
import { useTranslation } from "react-i18next";
import TechCard from "../TechCard/TechCard";

const LeetCode = ()=> {
    const { t } = useTranslation();
    const lcData = t("techPage", { returnObjects: true });
    return (
      <section id="passion" className="passion">
        <h2 className="passion__title">
          {t("techPageTitle.title1")}
          <span className="passion__title--special">
            {t("techPageTitle.title2")}
          </span>
        </h2>
        <div className="">
          {lcData.map((card, idx) => (
            <TechCard
              key={idx}
              image={card.image}
              targetUrl={card.targetUrl}
              content={card.content}
              description={card.description}
            />
          ))}
        </div>
      </section>
    );
}

export default LeetCode;